import React from "react";
import { IDatabaseLineItem, LineItemElementProps } from "../types";

interface Props {
	lineItemToProcess: LineItemElementProps[];
	lineItemToEdit?: IDatabaseLineItem;
	showEditTextInput: boolean;
	editingLineValue: string;
	editingIndex: number | null;
	containerRef: React.RefObject<HTMLDivElement>;
	onEditingLineValueChange: (value: string) => void;
	onEditTextToggle: () => void;
	onVariableClick: (ind: number, element: LineItemElementProps, rect: DOMRect) => void;
	onSaveClick: () => void;
	onCopyAll: () => void;
	onFixDB: () => void;
}

const LineItemEditor: React.FC<Props> = ({
	lineItemToProcess,
	lineItemToEdit,
	showEditTextInput,
	editingLineValue,
	editingIndex,
	containerRef,
	onEditingLineValueChange,
	onEditTextToggle,
	onVariableClick,
	onSaveClick,
	onCopyAll,
	onFixDB,
}) => {
	const hasValue = !!lineItemToProcess[0]?.value;

	return (
		<div
			ref={containerRef}
			className="text-gray-900  2xl:text-3xl xl:text-2xl md:text-xl sm:text-l font-light font-['Hanken Grotesk'] py-16 px-12 flex justify-between"
		>
			{showEditTextInput ? (
				<input value={editingLineValue} onChange={(e) => onEditingLineValueChange(e.target.value)} className="shrink grow" />
			) : (
				<div className="flex">
					{lineItemToProcess.map((element, ind) => {
						return (
							<React.Fragment key={ind}>
								<div className="whitespace-nowrap px-1">
									{element.type === "variable" && (
										<div
											className="bg-sky-100 rounded cursor-pointer"
											onClick={(e: any) => {
												const rect = e.target.getBoundingClientRect();
												onVariableClick(ind, element, rect);
											}}
										>
											<div className="p-1">{element.value}</div>
										</div>
									)}
									{element.type === "text" && (
										<div className="p-1 px-0">
											<div className="">{element.value}</div>
										</div>
									)}
								</div>
							</React.Fragment>
						);
					})}
				</div>
			)}
			<div>
				{location.href.includes("allowCopy=1") && (
					<button onClick={onCopyAll}> Copy All</button>
				)}
				<button onClick={onEditTextToggle}>
					<div
						className={`w-[131px] h-[60px] py-4  rounded-lg shadow border border-gray-200 justify-center items-center  inline-flex ${
							hasValue ? "bg-blue-900" : "bg-gray-100"
						}`}
					>
						<div className="h-6 relative" />
						<div
							className={`${
								hasValue ? "text-white" : "text-gray-300"
							}  text-lg font-semibold font-['Hanken Grotesk'] leading-7`}
						>
							{showEditTextInput ? "Close Edit" : "Edit Text"}
						</div>
					</div>
				</button>
				<button onClick={onSaveClick}>
					<div
						className={`w-[131px] h-[60px] px-7 py-4  rounded-lg shadow border border-gray-200 justify-center items-center gap-3 inline-flex ${
							hasValue ? "bg-blue-900" : "bg-gray-100"
						}`}
					>
						<img src={hasValue ? `/assets/ui/save-w.svg` : `/assets/ui/save-g.svg`} className="w-6 h-6 relative" />
						<div
							className={`${
								hasValue ? "text-white" : "text-gray-300"
							}  text-lg font-semibold font-['Hanken Grotesk'] leading-7`}
						>
							Save
						</div>
					</div>
				</button>
				{location.href.includes("allowDBFix=1") && (
					<>
						<button onClick={onFixDB}>
							<div
								className={`w-[131px] h-[60px] px-7 py-4  rounded-lg shadow border border-gray-200 justify-center items-center gap-3 inline-flex ${
									hasValue ? "bg-blue-900" : "bg-gray-100"
								}`}
							>
								<img src={hasValue ? `/assets/ui/save-w.svg` : `/assets/ui/save-g.svg`} className="w-6 h-6 relative" />
								<div
									className={`${
										hasValue ? "text-white" : "text-gray-300"
									}  text-lg font-semibold font-['Hanken Grotesk'] leading-7`}
								>
									Fix DB
								</div>
							</div>
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default LineItemEditor;
